// src/api/requests.js
import api from "./axios";

// POST
export async function submitUserRequest(payload) {
  const { data } = await api.post(`/requests`, payload);
  return data;
}

// 1) GET all requests, or filter by requestId if provided
export const getRequests = async (requestId) => {
  const url = requestId
    ? `/requests?requestId=${encodeURIComponent(requestId)}`
    : "/requests";

  const res = await api.get(url);
  return res.data;
};

// 2) PATCH /requests/:requestId/status
export const updateRequestStatus = async (requestId, status) => {
  const res = await api.patch(
    `/requests/${encodeURIComponent(requestId)}/status`,
    { status }
  );
  return res.data;
};

export const bulkUpdateRequests = (ids, status) =>
  api.patch("/requests/bulk", { ids, status }).then((r) => r.data);
